import _typeof from '../../node_modules/@babel/runtime/helpers/typeof.js';
import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _asyncToGenerator from '../../node_modules/@babel/runtime/helpers/asyncToGenerator.js';
import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import regenerator from '../../node_modules/@babel/runtime/regenerator/index.js';
import { SELF_REPORTED_CREDIT_LOOKUP } from '../../constants.js';
import { calculateAffforability, calculateHomePriceBasedOnDownPayment } from './calculations.js';
import { getConfigs } from './configs.js';

var _CREDIT_SCORE_MAPPING;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PROGRAM = 'Fixed30Year';
var LOAN_TYPE = 'Conventional';
var BE_CREDIT_SCORE = {
  Low: 'Low',
  High: 'High',
  VeryHigh: 'VeryHigh'
};
var CREDIT_SCORE_MAPPING = (_CREDIT_SCORE_MAPPING = {}, _defineProperty(_CREDIT_SCORE_MAPPING, SELF_REPORTED_CREDIT_LOOKUP.EXCELLENT, BE_CREDIT_SCORE.VeryHigh), _defineProperty(_CREDIT_SCORE_MAPPING, SELF_REPORTED_CREDIT_LOOKUP.GOOD, BE_CREDIT_SCORE.High), _defineProperty(_CREDIT_SCORE_MAPPING, SELF_REPORTED_CREDIT_LOOKUP.AVERAGE, BE_CREDIT_SCORE.Low), _defineProperty(_CREDIT_SCORE_MAPPING, SELF_REPORTED_CREDIT_LOOKUP.POOR, BE_CREDIT_SCORE.Low), _defineProperty(_CREDIT_SCORE_MAPPING, SELF_REPORTED_CREDIT_LOOKUP.BAD, BE_CREDIT_SCORE.Low), _CREDIT_SCORE_MAPPING);
var doFetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var response,
      data,
      _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch.apply(void 0, _args);
          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();
          case 5:
            data = _context.sent;
            if (!response.ok) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", data);
          case 8:
            return _context.abrupt("return", Promise.reject(data));
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function doFetch() {
    return _ref.apply(this, arguments);
  };
}();
var buildUrlQueryParams = function buildUrlQueryParams(query) {
  var filteredQuery = Object.entries(query).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      val = _ref3[1];
    return val === undefined || val === null || val === '' ? acc : _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, val));
  }, {});
  return new URLSearchParams(filteredQuery).toString();
};
var buildDotNotationQueryParams = function buildDotNotationQueryParams(query) {
  var arr = [];
  var recurse = function recurse(v, k) {
    if (typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean') {
      // Primitives
      arr.push("".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v)));
    } else if (_typeof(v) === 'object' && v !== null && (Object.keys(v).length > 0 || v.length)) {
      // Non-empty objects/arrays
      Object.keys(v).forEach(function (kk) {
        recurse(v[kk], k + '.' + kk);
      });
    } else if (typeof v !== 'undefined') {
      // Empty objects/arrays, null
      arr.push("".concat(encodeURIComponent(k), "="));
    }
  };
  Object.keys(query).forEach(function (k) {
    recurse(query[k], k);
  });
  return arr.length ? "".concat(arr.join('&')) : '';
};
var queryAutocomplete = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(inputs) {
    var _getConfigs, autocompleteBaseUrl, query, url;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getConfigs = getConfigs(), autocompleteBaseUrl = _getConfigs.autocompleteBaseUrl;
            query = buildUrlQueryParams(inputs);
            url = "".concat(autocompleteBaseUrl, "/v3/suggestions?").concat(query);
            _context2.prev = 3;
            _context2.next = 6;
            return doFetch(url);
          case 6:
            return _context2.abrupt("return", _context2.sent);
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9]]);
  }));
  return function queryAutocomplete(_x) {
    return _ref4.apply(this, arguments);
  };
}();
var getRegionInformation = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(latitude, longitude) {
    var _getConfigs2, maxBaseUrl, partnerId, query, url, response;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getConfigs2 = getConfigs(), maxBaseUrl = _getConfigs2.maxBaseUrl, partnerId = _getConfigs2.partnerId;
            query = buildDotNotationQueryParams({
              locationRef: {
                coordinates: {
                  latitude: latitude,
                  longitude: longitude
                }
              },
              partnerId: partnerId
            });
            url = "".concat(maxBaseUrl, "/getRegionInformation?").concat(query);
            _context3.prev = 3;
            _context3.next = 6;
            return doFetch(url);
          case 6:
            response = _context3.sent;
            return _context3.abrupt("return", response);
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](3);
          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 10]]);
  }));
  return function getRegionInformation(_x2, _x3) {
    return _ref5.apply(this, arguments);
  };
}();

// TODO consume WIP getCurrentZHLRates v2
var cachedRate = {};
var _fetchRate = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(maxBaseUrl, query) {
    var _response$rates, _response$rates$PROGR;
    var response;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(cachedRate[query] >= 0)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", cachedRate[query]);
          case 2:
            _context4.next = 4;
            return doFetch("".concat(maxBaseUrl, "/getCurrentRates?").concat(query));
          case 4:
            response = _context4.sent;
            cachedRate[query] = response === null || response === void 0 ? void 0 : (_response$rates = response.rates) === null || _response$rates === void 0 ? void 0 : (_response$rates$PROGR = _response$rates[PROGRAM]) === null || _response$rates$PROGR === void 0 ? void 0 : _response$rates$PROGR.rate;
            return _context4.abrupt("return", cachedRate[query]);
          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function _fetchRate(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();
var _buildRateQuery = function _buildRateQuery(_ref7) {
  var partnerId = _ref7.partnerId,
    creditScore = _ref7.creditScore,
    propertyBucket = _ref7.propertyBucket;
  return buildDotNotationQueryParams({
    partnerId: partnerId,
    queries: _defineProperty({}, PROGRAM, {
      program: PROGRAM,
      loanType: LOAN_TYPE,
      creditScoreBucket: CREDIT_SCORE_MAPPING[creditScore],
      propertyBucket: propertyBucket
    })
  });
};
var buildDefaultRateQuery = function buildDefaultRateQuery(_ref8) {
  var partnerId = _ref8.partnerId,
    creditScore = _ref8.creditScore;
  return _buildRateQuery({
    partnerId: partnerId,
    creditScore: creditScore
  });
};
var buildRateQueryWithPropertyBucket = function buildRateQueryWithPropertyBucket(_ref9) {
  var partnerId = _ref9.partnerId,
    homePrice = _ref9.homePrice,
    downPayment = _ref9.downPayment,
    zipCode = _ref9.zipCode,
    creditScore = _ref9.creditScore;
  var propertyValue = Math.round(homePrice);
  // fallback to national rate if zip code is not available
  var location = zipCode ? {
    zipCode: zipCode
  } : {
    stateAbbreviation: 'US'
  };
  var propertyBucket = {
    propertyValue: propertyValue,
    loanAmount: Math.round(propertyValue - downPayment),
    location: location
  };
  return _buildRateQuery({
    partnerId: partnerId,
    creditScore: creditScore,
    propertyBucket: propertyBucket
  });
};
var fetchRate = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(_ref10) {
    var homePrice, downPayment, zipCode, creditScore, _getConfigs3, maxBaseUrl, partnerId, zipCodeRateQuery, zipCodeRate, nationalRateQuery, nationalRate, defaultRateQuery;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            homePrice = _ref10.homePrice, downPayment = _ref10.downPayment, zipCode = _ref10.zipCode, creditScore = _ref10.creditScore;
            _getConfigs3 = getConfigs(), maxBaseUrl = _getConfigs3.maxBaseUrl, partnerId = _getConfigs3.partnerId; // location specific rate
            zipCodeRateQuery = buildRateQueryWithPropertyBucket({
              partnerId: partnerId,
              homePrice: homePrice,
              downPayment: downPayment,
              zipCode: zipCode,
              creditScore: creditScore
            });
            _context5.next = 5;
            return _fetchRate(maxBaseUrl, zipCodeRateQuery);
          case 5:
            zipCodeRate = _context5.sent;
            if (!(zipCodeRate > 0)) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return", zipCodeRate);
          case 8:
            // fallback to national rate
            nationalRateQuery = buildRateQueryWithPropertyBucket({
              partnerId: partnerId,
              homePrice: homePrice,
              downPayment: downPayment,
              creditScore: creditScore
            });
            _context5.next = 11;
            return _fetchRate(maxBaseUrl, nationalRateQuery);
          case 11:
            nationalRate = _context5.sent;
            if (!(nationalRate > 0)) {
              _context5.next = 14;
              break;
            }
            return _context5.abrupt("return", nationalRate);
          case 14:
            // default fallback due to jumbo and low credit score combination
            defaultRateQuery = buildDefaultRateQuery({
              partnerId: partnerId,
              creditScore: creditScore
            });
            _context5.next = 17;
            return _fetchRate(maxBaseUrl, defaultRateQuery);
          case 17:
            return _context5.abrupt("return", _context5.sent);
          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function fetchRate(_x6) {
    return _ref11.apply(this, arguments);
  };
}();
var cachedAnnualPropertyTaxRates = {};
var getAnnualPropertyTaxRate = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(zipCode) {
    var _getConfigs4, maxBaseUrl, partnerId, query, response;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!cachedAnnualPropertyTaxRates[zipCode]) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return", cachedAnnualPropertyTaxRates[zipCode]);
          case 2:
            _getConfigs4 = getConfigs(), maxBaseUrl = _getConfigs4.maxBaseUrl, partnerId = _getConfigs4.partnerId;
            query = buildUrlQueryParams({
              zipCode: zipCode,
              partnerId: partnerId
            });
            _context6.next = 6;
            return doFetch("".concat(maxBaseUrl, "/getAnnualPropertyTaxRate?").concat(query));
          case 6:
            response = _context6.sent;
            cachedAnnualPropertyTaxRates[zipCode] = response === null || response === void 0 ? void 0 : response.rate;
            return _context6.abrupt("return", cachedAnnualPropertyTaxRates[zipCode]);
          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function getAnnualPropertyTaxRate(_x7) {
    return _ref12.apply(this, arguments);
  };
}();
var performCalculation = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(_ref13) {
    var annualIncome, monthlyDebts, downPayment, creditScore, zipCode, state, homePrice, mortgageRate, propertyTaxRate;
    return regenerator.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            annualIncome = _ref13.annualIncome, monthlyDebts = _ref13.monthlyDebts, downPayment = _ref13.downPayment, creditScore = _ref13.creditScore, zipCode = _ref13.zipCode, state = _ref13.state;
            homePrice = calculateHomePriceBasedOnDownPayment(downPayment);
            _context7.next = 4;
            return fetchRate({
              homePrice: homePrice,
              downPayment: downPayment,
              creditScore: creditScore,
              zipCode: zipCode
            });
          case 4:
            mortgageRate = _context7.sent;
            _context7.next = 7;
            return getAnnualPropertyTaxRate(zipCode);
          case 7:
            propertyTaxRate = _context7.sent;
            return _context7.abrupt("return", calculateAffforability({
              annualIncome: annualIncome,
              monthlyDebts: monthlyDebts,
              downPayment: downPayment,
              mortgageRate: mortgageRate,
              propertyTaxRate: propertyTaxRate,
              creditScore: creditScore,
              state: state
            }));
          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function performCalculation(_x8) {
    return _ref14.apply(this, arguments);
  };
}();

export { buildUrlQueryParams, getRegionInformation, performCalculation, queryAutocomplete };
//# sourceMappingURL=api.js.map
